export const DEFAULT_CROP_DIMENSIONS = { maxWidth: '100%' };
